import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { faceplateMessages } from './faceplateMessages';

export const FaceplateMissing = () => (
    <div className="faceplate-missing">
        <FormattedMessage {...faceplateMessages.noImageAvailable} />
    </div>
);

export const PureFaceplateImage = ({ imageURL, altText, cssClass }) => (
    <img className={cssClass} src={imageURL} alt={altText} />
);

PureFaceplateImage.defaultProps = {
    cssClass: 'mf-faceplate-img'
};

PureFaceplateImage.propTypes = {
    imageURL: PropTypes.string.isRequired,
    altText: PropTypes.string.isRequired,
    cssClass: PropTypes.string
};

export const FaceplateImg = ({ faceplate, cssClass }) => {
    if (!faceplate) return <FaceplateMissing />;
    const { imageURL, altText } = faceplate;

    return (
        <PureFaceplateImage
            cssClass={cssClass}
            imageURL={imageURL}
            altText={altText || 'Gift card image'}
        />
    );
};

FaceplateImg.defaultProps = {
    faceplate: null,
    cssClass: null
};

FaceplateImg.propTypes = {
    faceplate: PropTypes.object,
    cssClass: PropTypes.string
};
